import {
  NodeUtils,
  createBlock,
  mergeBlock,
  t,
} from "@easy-email-pro-core/utils";

import { ElementCategory, ElementType } from "@easy-email-pro-core/constants";
import {
  HTMLDomNodeElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import {
  BasicBlock,
  BlockRenderer,
  ContentLeaf,
} from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<HTMLDomNodeElement>["defaultData"] = {
  attributes: {},
  data: {
    tagName: "div",
  },
};

export const HtmlDomNode = createBlock<HTMLDomNodeElement>({
  get name() {
    return t("HTML dom node");
  },
  defaultData,
  type: ElementType.HTML_DOM_NODE,
  create: (payload) => {
    const defaultData: HTMLDomNodeElement = {
      type: ElementType.HTML_DOM_NODE,
      data: {
        tagName: "div",
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.UNKNOWN_CONTENT,
  render(params) {
    const { node, idx } = params;
    if (params.mode === "production") {
      return (
        <>
          {node.children.map((child, index) => {
            if (NodeUtils.isTextNode(child)) {
              if (NodeUtils.isTextListElement(node)) {
                return (
                  <React.Fragment key={index}>
                    {`<li>`}
                    <ContentLeaf key={index} {...params} node={child} />
                    {`</li>`}
                  </React.Fragment>
                );
              }
              return <ContentLeaf key={index} {...params} node={child} />;
            }
            return (
              <BlockRenderer
                key={index}
                {...params}
                idx={idx ? NodeUtils.getChildIdx(idx, index) : null}
                node={child}
              />
            );
          })}
        </>
      );
    }
    return (
      <BasicBlock
        tag={params.node.data.tagName || "div"}
        params={{
          ...params,
          node: {
            ...params.node,
            attributes: {
              "element-type": ElementType.HTML_DOM_NODE,
              "element-category": ElementCategory.UNKNOWN_CONTENT,
              "element-data": encodeURIComponent(
                JSON.stringify(params.node.data)
              ),
              "element-attributes": encodeURIComponent(
                JSON.stringify(params.node.attributes)
              ),
            } as any,
          },
        }}
      />
    );
  },
});
